module.exports = {"130803001":"元宝山街道","130803002":"钢城街道","130803003":"秀水街道","130803100":"双塔山镇","130803101":"滦河镇","130803102":"大庙镇","130803103":"偏桥子镇","130803104":"西地镇","130803105":"陈栅子镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130803.json
// module id = 288
// module chunks = 0